import { SwitchComponent } from './../components/forms/switch/switch.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaComponent } from '../components/recaptcha/recaptcha.component';
import { LazyLoadImageModule } from 'ng-lazyload-image'; // <-- import it
import { AccordionModule } from './components/accordion/accordion.module';
import { ListingAddressModule } from './components/address/listing-address.module';
import { CmsLinksModule } from './components/cms-links/cms-links.module';
import { DemographicItemModule } from './components/demographic/demographic-item.module';
import { DropdownModule } from './components/dropdown/dropdown.module';
import { EnhancedContentModule } from './components/enhanced-content/enhanced-content.module';
import { EstimatedValueModule } from './components/estimated-value/estimated-value.module';
import { ItemSwiperModule } from './components/item-swiper/item-swiper.module';
import { LinkCardModule } from './components/link-card/link-card.module';
import { ListingDetailsCardModule } from './components/listing-details-card/listing-details-card.module';
import { ListingPriceArrowModule } from './components/listing-price-arrow/listing-price-arrow.module';
import { MapModule } from './components/map/map.module';
import { EmailShareModalModule } from './components/modals/email-share-modal/email-share-modal.module';
import { PoiWidgetModule } from './components/poi-widget/poi-widget.module';
import { PropertyDetailsModule } from './components/property-details/property-details.module';
import { RatingModule } from './components/rating/rating.module';
import { RmCarouselModule } from './components/rm-carousel/rm-carousel.module';
import { LoaderModule } from '../components/loader/loader.module';
import { InputModule } from '../components/forms/input/input.module';
import { RecaptchaModule } from '../components/recaptcha/recaptcha.module';
import { SwitchModule } from '../components/forms/switch/switch.module';
import { ItemSwiperComponent } from './components/item-swiper/item-swiper.component';
import { ListingDetailsCardComponent } from './components/listing-details-card/listing-details-card.component';
import { PropertyDetailsComponent } from './components/property-details/property-details.component';
import { RmCarouselComponent } from './components/rm-carousel/rm-carousel.component';
import { ListingPriceArrowComponent } from './components/listing-price-arrow/listing-price-arrow.component';
import { ListingAddressComponent } from './components/address/listing-address.component';
import { MapComponent } from './components/map/map.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { AccordionItemComponent } from './components/accordion/item/accordion-item.component';
import { DemographicItemComponent } from './components/demographic/demographic-item.component';
import { RatingComponent } from './components/rating/rating.component';
import { CmsLinksComponent } from './components/cms-links/cms-links.component';
import { EstimatedValueComponent } from './components/estimated-value/estimated-value.component';
import { EnhancedContentComponent } from './components/enhanced-content/enhanced-content.component';
import { LinkCardComponent } from './components/link-card/link-card.component';
import { PoiWidgetComponent } from './components/poi-widget/poi-widget.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { EmailShareModalComponent } from './components/modals/email-share-modal/email-share-modal.component';
import { TabsModule } from './components/tabs/tabs.module';
import { TabsComponent } from './components/tabs/tabs.component';
import { ListingCardModule } from './components/listing-card/listing-card.module';
import { ListingCardComponent } from './components/listing-card/listing-card.component';
import { DropdownContainerModule } from './components/dropdown-container/dropdown-container.module';
import { DropdownContainerComponent } from './components/dropdown-container/dropdown-container.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    RouterModule.forChild([]),
    FormsModule,
    ReactiveFormsModule,
    LazyLoadImageModule,
    AccordionModule,
    ListingAddressModule,
    CmsLinksModule,
    DemographicItemModule,
    DropdownModule,
    EnhancedContentModule,
    EstimatedValueModule,
    ItemSwiperModule,
    LinkCardModule,
    ListingDetailsCardModule,
    ListingPriceArrowModule,
    MapModule,
    EmailShareModalModule,
    PoiWidgetModule,
    PropertyDetailsModule,
    RatingModule,
    RmCarouselModule,
    LoaderModule,
    InputModule,
    RecaptchaModule,
    SwitchModule,
    TabsModule,
    ListingCardModule,
    DropdownContainerModule
  ],
  declarations: [],
  exports: [
    ItemSwiperComponent,
    ListingDetailsCardComponent,
    ListingCardComponent,
    PropertyDetailsComponent,
    RmCarouselComponent,
    ListingPriceArrowComponent,
    ListingAddressComponent,
    MapComponent,
    AccordionComponent,
    AccordionItemComponent,
    DemographicItemComponent,
    RatingComponent,
    CmsLinksComponent,
    EstimatedValueComponent,
    EnhancedContentComponent,
    LinkCardComponent,
    PoiWidgetComponent,
    DropdownComponent,
    DropdownContainerComponent,
    EmailShareModalComponent,
    SwitchComponent,
    RecaptchaComponent,
    TabsComponent,
    InputModule,
    LazyLoadImageModule
  ]
})
export class SharedModule {}
